// Placeholder utilities - to be implemented
export const API_ENDPOINTS = {
  ADVENTURES: '/api/adventures',
  SESSIONS: '/api/sessions',
  PLAYERS: '/api/sessions/:sessionId/players',
} as const;

export const WEBSOCKET_EVENTS = {
  JOIN_SESSION: 'join-session',
  LEAVE_SESSION: 'leave-session',
  PLAYER_ACTION: 'player-action',
  STATE_UPDATE: 'state-update',
  WAITING_UPDATE: 'waiting-update',
  ADVENTURE_TOAST: 'adventure-toast',
} as const;

export const GAME_CONSTANTS = {
  MAX_PLAYERS: 6,
  SESSION_TIMEOUT: 3600000,
  RECONNECT_ATTEMPTS: 5,
  RECONNECT_DELAY: 3000,
} as const;
